import React from 'react'
import PropTypes from 'prop-types'
import {
  ContentSetWrapper,
  StyledContentTypeDescription,
} from './component.styles'
import { contentfulImageShape } from 'utils/shapes'
import { createShutterList } from './utils'

const ShutterList = ({
  className,
  contentDescription,
  items = [],
  renderItem,
  callout,
  renderCalloutItem,
  renderContentDescription,
}) => {
  return (
    <ContentSetWrapper
      className={className}
      hasFooter={contentDescription?.hasFooter}
    >
      {contentDescription &&
        (renderContentDescription ? (
          renderContentDescription(contentDescription)
        ) : (
          <StyledContentTypeDescription {...contentDescription} />
        ))}
      {callout && renderCalloutItem && (
        <React.Fragment>
          {renderCalloutItem({
            ...callout,
            path: callout.route,
          })}
        </React.Fragment>
      )}
      {renderItem &&
        items &&
        items
          ?.filter(item => !!item?.description && !!item?.title && !!item?.path)
          .map((item, i) => (
            <React.Fragment key={i}>
              {renderItem?.({
                ...item,
              })}
            </React.Fragment>
          ))}
    </ContentSetWrapper>
  )
}

ShutterList.propTypes = {
  callout: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    route: PropTypes.string,
  }),
  className: PropTypes.string,
  contentDescription: PropTypes.shape({
    backgroundColor: PropTypes.string,
    backgroundImage: PropTypes.string,
    body: PropTypes.string,
    bodyColor: PropTypes.string,
    borderColor: PropTypes.string,
    dataTestId: PropTypes.string,
    descriptionImage: contentfulImageShape,
    descriptionPdf: PropTypes.array,
    footerChildren: PropTypes.node,
    hasFooter: PropTypes.bool,
    id: PropTypes.string,
    singleLink: PropTypes.shape({
      text: PropTypes.string,
      href: PropTypes.string,
      color: PropTypes.string,
      hoverColor: PropTypes.string,
    }),
    title: PropTypes.string,
    titleColor: PropTypes.string,
  }),
  items: PropTypes.arrayOf(
    PropTypes.shape({
      description: PropTypes.string,
      title: PropTypes.string,
      path: PropTypes.string,
    }),
  ),
  renderCalloutItem: PropTypes.func,
  renderContentDescription: PropTypes.func,
  renderItem: PropTypes.func,
}

export default ShutterList

export { createShutterList }
